// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"cf817630","simpleIconButton":"d8970b44","hoverContainerOuter":"cfb80698","simpleIcon":"d4420ea2","smallIcon":"abbbec3f","noHover":"c8dad464"};